import type { ReactNode } from "react";
import styles from "./DetailList.module.scss";

type DetailListItem = {
  label: ReactNode;
  value: ReactNode;
};

type DetailListProps = {
  items: DetailListItem[];
  className?: string;
};

const DetailList = ({ items, className }: DetailListProps) => {
  return (
    <div className={`${styles.infoCard}${className ? ` ${className}` : ""}`}>
      {items.map((item, index) => (
        <div key={index} className={styles.infoRow}>
          <span className={styles.infoLabel}>{item.label}</span>
          <span className={styles.infoValue}>{item.value}</span>
        </div>
      ))}
    </div>
  );
};

export default DetailList;
